const e = (e, t) => t.split(".").reduce((e, t) => e && e[t] ? e[t] : void 0, e);
export { e as default };
